const acceptedCreditCards = {
  visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
  mastercard:
  /^5[1-5]\d{2}-?\d{4}-?\d{4}-?\d{4}$|^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d\d|7(?:[01]\d|20))-?\d{4}-?\d{4}-?\d{4}$/,
  amex: /^3[47][0-9]{13}$/,
  discover:
    /^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
  diners_club: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
  jcb: /^(?:2131|1800|35[0-9]{3})[0-9]{11}$/,
  //elo: /^(40117[8-9]|431274|438935|451416|457393|45763[1-2]|506(699|7[0-6][0-9]|77[0-8])|509\d{3}|504175|627780|636297|636368|65003[1-3]|6500(3[5-9]|4[0-9]|5[0-1])|6504(0[5-9]|[1-3][0-9])|650(4[8-9][0-9]|5[0-2][0-9]|53[0-8])|6505(4[1-9]|[5-8][0-9]|9[0-8])|6507(0[0-9]|1[0-8])|65072[0-7]|6509(0[1-9]|1[0-9]|20)|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/
  elo: /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/
}

const cardFlagPrediction = {
  visa: /^4[0-9]*$/,
  mastercard: /^5[1-5]\d{2}-?\d{4}-?\d{4}-?\d{4}$|^2(?:2(?:2[1-9]|[3-9]\d)|[3-6]\d\d|7(?:[01]\d|20))-?\d{4}-?\d{4}-?\d{4}$/,
  amex: /^3[47][0-9]*$/,
  diners: /^3(?:0[0-5]|[68][0-9])[0-9]*/,
  //elo: /^(40117[8-9]|431274|438935|451416|457393|45763[1-2]|506(699|7[0-6][0-9]|77[0-8])|509\d{3}|504175|627780|636297|636368|65003[1-3]|6500(3[5-9]|4[0-9]|5[0-1])|6504(0[5-9]|[1-3][0-9])|650(4[8-9][0-9]|5[0-2][0-9]|53[0-8])|6505(4[1-9]|[5-8][0-9]|9[0-8])|6507(0[0-9]|1[0-8])|65072[0-7]|6509(0[1-9]|1[0-9]|20)|6516(5[2-9]|[6-7][0-9])|6550([0-1][0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/
  elo: /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/
}

export const validateCard = (cardNumber) => {
  if (/[^0-9-\s]+/.test(cardNumber)) return false

  // Algorítmo de Luhn com a lógica de numeração de cartões
  let nCheck = 0,
    bEven = false
  cardNumber = cardNumber.replace(/\D/g, '')

  for (let n = cardNumber.length - 1; n >= 0; n--) {
    let cDigit = cardNumber.charAt(n),
      nDigit = parseInt(cDigit, 10)

    if (bEven && (nDigit *= 2) > 9) nDigit -= 9

    nCheck += nDigit
    bEven = !bEven
  }

  let valid = nCheck % 10 == 0
  let accepted = false

  Object.keys(acceptedCreditCards).forEach((key) => {
    var regex = acceptedCreditCards[key]
    if (regex.test(cardNumber)) {
      accepted = true
    }
  })
  return valid && accepted
}

export const getCardFlag = (cardNumber) => {
  cardNumber = cardNumber.replace(/[^0-9]+/g, '')
  let flag

  Object.keys(cardFlagPrediction).forEach((key) => {
    var regex = cardFlagPrediction[key]
    if (regex.test(cardNumber)) {
      flag = key
    }
  })
  return flag
}

export const formatCardNumber = (cardNumber) => {
  let value = cardNumber.replace(/\D/g, '')
  let formattedValue

  // CC American Express - 15 digits
  if (/^3[47]\d{0,13}$/.test(value)) {
    formattedValue = value
      .replace(/\D/g, '')
      .replace(/^(\d{4})(\d)/g, '$1 $2')
      .replace(/^(\d{4})\s(\d{6})(\d)/g, '$1 $2 $3')
      .replace(/^(\d{4})\s(\d{6})\s(\d{5})(\d)/g, '$1 $2 $3')
  } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
    // CC Diner's club - 14 digitos
    formattedValue = value
      .replace(/\D/g, '')
      .replace(/^(\d{4})(\d)/g, '$1 $2')
      .replace(/^(\d{4})\s(\d{6})(\d)/g, '$1 $2 $3')
      .replace(/^(\d{4})\s(\d{6})\s(\d{4})(\d)/g, '$1 $2 $3')
  } else if (/^\d{0,16}$/.test(value)) {
    // CC padrão - 16 dígitos
    formattedValue = value
      .replace(/\D/g, '')
      .replace(/^(\d{4})(\d)/g, '$1 $2')
      .replace(/^(\d{4})\s(\d{4})(\d)/g, '$1 $2 $3')
      .replace(/^(\d{4})\s(\d{4})\s(\d{4})(\d)/g, '$1 $2 $3 $4')
  }
  return formattedValue
}

export const validateCVV = (cvv, cardFlag) => {
  cvv.replace(/\D/g, '')

  if (cardFlag === undefined) {
    return false
  } else if (cardFlag !== undefined && /^\d{3}$/.test(cvv)) {
    return true
  } else if (cardFlag === 'amex' && /^\d{4}$/.test(cvv)) {
    return true
  }
}
